import { render, staticRenderFns } from "./annualFee.vue?vue&type=template&id=3083ac0d&scoped=true&"
import script from "./annualFee.vue?vue&type=script&lang=js&"
export * from "./annualFee.vue?vue&type=script&lang=js&"
import style0 from "./annualFee.vue?vue&type=style&index=0&id=3083ac0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3083ac0d",
  null
  
)

export default component.exports